import React, { SyntheticEvent } from 'react'
import { Button, Flex, Box } from 'pcln-design-system'
import { Sparkle } from 'pcln-icons'
import analytics from '@/shared-utils/analytics'

function ChatBotDialogOpenerButton({ onClick }: { onClick: () => void }) {
  return (
    <Button
      variation="link"
      onClick={(event: SyntheticEvent) => {
        event.preventDefault()
        onClick()
        analytics.fireEvent({
          category: 'pcln_home',
          action: 'penny_trigger',
          label: 'search_form'
        })
      }}
    >
      <Flex alignItems="center">
        <Sparkle />
        <Box ml={1}>Discover where to go with Penny!</Box>
      </Flex>
    </Button>
  )
}

export default ChatBotDialogOpenerButton
